import { Component, OnInit } from '@angular/core';
import { AwardsService } from '../awards.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayService } from '../../../shared/display.service';
import { CurrencyService } from '../../../shared/currency.service';
import { UrlService } from '../../../shared/url.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/shared/user/user.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';

@Component({
  selector: 'app-awards-bandgroup',
  templateUrl: './awards-bandgroup.component.html',
  styleUrls: ['./awards-bandgroup.component.scss']
})
export class AwardsBandgroupComponent implements OnInit {

  awardsBandGroupData: any[];
  dtOptions: DataTables.Settings = {};
  regionCodes: string[] = [];

  constructor(
    private awardsService: AwardsService,
    private route: ActivatedRoute,
    private userService: UserService,
    public displayService: DisplayService,
    private router: Router,
    public analyticsService: AnalyticsService,
    public currencyService: CurrencyService,
    public urlService: UrlService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.dtOptions = {
      "lengthChange": false,
      "searching": false,
      "paging": false,
      "info": false,
      "columnDefs": [
        { "orderable": false, "targets": 2 },
        { "orderable": false, "targets": 8 },
      ]
    };
    combineLatest(this.route.params, this.route.queryParams)
      .pipe(map(results => ({ bandGroup: results[0].bandGroup, query: results[1] })))
      .subscribe(results => {
        if (results.query && results.query.regionCode) {
          this.regionCodes = this.regionCodes.concat(results.query.regionCode);
        } else {
          this.regionCodes = this.regionCodes.concat(this.userService.getRegions());
        }
        this.awardsService.getAwardsByBandGroup(this.regionCodes, results.bandGroup)
          .subscribe(data => {
            this.awardsBandGroupData = data;
          });
      });
  }

  getDocumentUrl(uniqueNumber: string): string {
    return this.urlService.getClientSiteUrl(uniqueNumber);
  }

  hideStatus(row: any): boolean {
    return !row.status && !row.statusComment;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return '';
    } else {
      return value;
    }
  }
}
